import {
  AppConfig,
  DirectFlightsRequest,
  Mapper,
  RMAutoCompleteResponse,
  RMDestinationsResponse,
  RMFlightQueryResponse,
  RMMarkerListResponse,
} from "./types";

export async function retrieveDestinations(
  request,
  appConfig: AppConfig
): Promise<RMDestinationsResponse> {
  const response = await fetch(
    `${retrieveBackendUrl(appConfig)}ConnectionBuilder/Destinations.ashx`,
    {
      method: "POST",
      body: JSON.stringify(request),
    });
  return await response.json();
}

export async function retrieveDirectMarkers(
  request,
  appConfig: AppConfig
): Promise<RMMarkerListResponse> {
  const response = await fetch(
    `${retrieveBackendUrl(appConfig)}ConnectionBuilder/DirectMarkers.ashx`,
    {
      method: "POST",
      body: JSON.stringify(request),
    }
  );
  return await response.json();
}

export async function retrieveConnectionMarkersAirport(
  request,
  appConfig: AppConfig
): Promise<RMMarkerListResponse> {
  const response = await fetch(
    `${retrieveBackendUrl(
      appConfig
    )}ConnectionBuilder/ConnectionMarkersAirport.ashx`,
    {
      method: "POST",
      body: JSON.stringify(request),
    }
  );
  return await response.json();
}

export async function retrieveDirectMarkersAirport(
  request,
  appConfig: AppConfig
): Promise<RMMarkerListResponse> {
  const response = await fetch(
    `${retrieveBackendUrl(
      appConfig
    )}ConnectionBuilder/DirectMarkersAirport.ashx`,
    {
      method: "POST",
      body: JSON.stringify(request),
    }
  );
  return await response.json();
}

export async function searchDirect(
  request: DirectFlightsRequest,
  appConfig: AppConfig
): Promise<RMFlightQueryResponse> {
  const response = await fetch(
    `${retrieveBackendUrl(appConfig)}ConnectionBuilder/Directs.ashx`,
    {
      method: "POST",
      body: JSON.stringify(request),
    }
  );
  return await response.json();
}

export async function searchConnection(
  request: DirectFlightsRequest,
  appConfig: AppConfig
): Promise<RMFlightQueryResponse> {
  const response = await fetch(
    `${retrieveBackendUrl(appConfig)}ConnectionBuilder/Connections.ashx`,
    {
      method: "POST",
      body: JSON.stringify(request),
    }
  );
  return await response.json();
}

export async function autocompleteAirports(
  appConfig: AppConfig,
  mapper: Mapper,
  criteria
): Promise<RMAutoCompleteResponse> {
  const response = await fetch(
    `${retrieveBackendUrl(appConfig)}Autocomplete.ashx?lang=${
      appConfig.language
    }-${appConfig.customerId}&pattern=${criteria}&type=${
      mapper.autocomplete.searchType
    }`
  );
  return await response.json();
}

export async function retrieveCustomerData(accCustId: string) {
  return await import(`./customers/config/${accCustId}.json`);
}

export async function retrieveAirlineLinks() {
  const response = await fetch(`${import.meta.env.BASE_URL}/airline-links.json`);
  return await response.json();
}

function retrieveBackendUrl(appConfig: AppConfig) {
  if (window.location.host.startsWith("localhost")) {
    return import.meta.env.VITE_BACKEND_URL;
  } else {
    return `${appConfig.serviceRoute}`;
  }
}
